<script>
export default {

}
</script>

<template>
  <div class="sm">
    <img src="@/assets/提煤备份.jpg" width="100%" height="100%" alt="" v-if="$route.path === '/sm'">
    <img src="@/assets/提煤.jpg" width="100%" height="100%" alt="" v-if="$route.path === '/tm'">
    <img src="@/assets/发运备份.jpg" width="100%" height="100%" alt="" v-if="$route.path === '/fy'">
    <img src="@/assets/一屏备份.jpg" width="100%" height="100%" alt="" v-if="$route.path === '/sp'">
  </div>
</template>

<style scoped>
.sm {
  width: 100%;
  height: 100%;
}
</style>